var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Page',{attrs:{"transfer":"","show-total":"","show-sizer":"","size":"small","total":_vm.total,"current":_vm.pageNo,"page-size":_vm.pageSize,"page-size-opts":[25, 50, 100],"class-name":"n-table-pagination"},on:{"on-change":v => _vm.$emit('on-page-no', v),"on-page-size-change":v => _vm.$emit('on-page-size', v)}})
}
var staticRenderFns = []

export { render, staticRenderFns }